//合同状态
const contract = {
  WAIT_CONFIRM: "待确认",
  TAKE_EFFECTIVE: "已生效",
  TAKE_REJECT: "已驳回",
  AT_TIME: "已到期"
};
//合同变更状态
const contractChangeStauts = {
  NO_CHANGE: "无变更",
  IN_CHANGE: "变更中",
  CHANGED: "已变更"
};
//货柜状态
const terminalTypes = {
  OPERATE: "正常",
  TAKE_DOWNLINE: "下线",
  // 'FAULT': '故障',
  EXPIRE: "合同到期"
};
// 网络状态
const network_status = {
  ONLINE:'在线',
  OFFLINE:'离线'

};
//备货状态
const stockStatus = {
  READY: "待处理",
  ALREADY: "已处理",
  CANCEL: "已取消"
};
//备货操作类别
const businessType = {
  UP: "商品上架",
  DOWN: "商品下架",
  // 'REPLACE_ITEMS': '同类商品更换',
  REPLACE: "更换货道商品"
};
//订单状态
const orderStatus = {
  WAIT_PAY: "待支付",
  TRADE_SUCCESS: "已付款",
  WAIT_CHECK: "处理中",
  // HAS_REFUND: "有退款",
  TOTAL_REFUND: "全额退款",
  PARTIAL_REFUND: "部分退款",
  NO_REFUND: "无退款",
  ORDER_CLOSE: "交易成功"
};
const auditStatus = {
  AUDIT: "申请中",
  TAKE_AUDIT: "已审核",
  REJECT: "已拒绝",
  CANCEL: "已取消"
};
const voucherAudit = {
  0: "审核中",
  1: "审核成功",
  2: "审核失败",
  3: "已取消"
};
const machineAudit = {
  0: "审核中",
  1: "审核成功",
  2: "审核失败",
};
//活动类型
const activityType = {
  NEW_COUPON: "新人券",
  SHOPPING_COUPONS: "购物赠券"
};
//支付方式
const payment = {
  WECHAT: "微信",
  ALIPAY: "支付宝",
  BUSINESS_BANK: "工商银行",
  AGRICULTURE_BANK: "农业银行",
  CHINA_BANK: "中国银行",
  CONSTRUCTION_BANK: "建设银行",
  TRAFFIC_BANK: "交通银行",
  INVESTMENT_BANK: "招商银行"
};
//分账配置
const splitBillType = {
  MERCHANT_ID: "商户平台ID",
  PERSONAL_WECHATID: "个人微信号"
};
//
const reportErrorType = {
  RECOGNITIONERROR: "识别错误",
  MACHINEERROR: "机器故障",
  NUMBERERROR: "数量错误",
  TOTALCOUNTERROR: "总金额有误",
  OTHER: "其他"
};
const pickerOptions = {
  shortcuts: [
    {
      text: "最近一周",
      onClick: function(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近一个月",
      onClick: function(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近三个月",
      onClick: function(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
      }
    }
  ]
};

export {
  contract,
  contractChangeStauts,
  terminalTypes,
  network_status,
  stockStatus,
  businessType,
  orderStatus,
  activityType,
  payment,
  splitBillType,
  auditStatus,
  voucherAudit,
  pickerOptions,
  reportErrorType,
  machineAudit,
};
